import React from 'react';
import { DayContent } from 'react-day-picker';

/**
 * Wrap DayContent element to insert custom CSS class name
 * @param {*} props
 * @returns wrapped React element with custom class name "hedtech-day"
 */
export default function CustomDayContent(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "hedtech-day"
  }, /*#__PURE__*/React.createElement(DayContent, props));
}